import axios from "axios";
import Swal from "sweetalert2";
const patientId = localStorage.getItem("patient_id");
const patId = localStorage.getItem("pat_id");
const role = localStorage.getItem("role");
const ipAddress = "194.238.17.244";
const userLocation = localStorage.getItem('userLocation');
const baseUrl = `${window.location.origin}/api/`;
const baseimgUrl = `${window.location.origin}/`;
const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const date = new Date(dateTimeStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
// ===================================================
// REQUEST INTERCEPTOR
// ===================================================
axios.interceptors.request.use(
    (config) => {
        const tokens = localStorage.getItem("patAuthTokens");
        if (tokens) {
            const access = JSON.parse(tokens).access;
            config.headers.Authorization = `Bearer ${access}`;
        }
        const hospitalCode = localStorage.getItem("hospital_code");
        if (hospitalCode) {
            config.headers["X-Hospital-Code"] = hospitalCode;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
// ===================================================
// RESPONSE INTERCEPTOR
// ===================================================
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;
            let message = "An error occurred";
            switch (status) {
                case 400:
                    message = "Bad Request";
                    break;
                case 401:
                    message = "Session Expired. Please login again.";
                    break;
                case 403:
                    message = "Permission Denied";
                    break;
                case 404:
                    message = "Data Not Found";
                    break;
                case 500:
                    message = "Internal Server Error";
                    break;
                default:
                    message =
                        error.response.data?.detail ||
                        "An error occurred";
            }
            Swal.fire({
                icon: "error",
                title: `Error ${status}`,
                text: message,
                confirmButtonText: "OK",
            });
        }
        return Promise.reject(error);
    }
);
export {
    baseUrl,
    baseimgUrl,
    patientId,
    patId,
    role,
    ipAddress,
    formatDateTime,
    userLocation,
};
export default axios;